import Head from "next/head";
import dynamic from "next/dynamic";
import { maxString } from "../../js/config/helpers";
import PageContextWrapper from "@components/Components/Reusables/PageContextWrapper";
import { getClientIp } from "utils/requestHelpers";
import { handleRateLimit } from "utils/handleRateLimit";

const LandingPageLayout = dynamic(() => import("../../js/Components/LandingPages/LandingPageLayout"));

const area = ({ data }) => {

    const {
        place
    } = data;

    return (
        <>
            <Head>
                <title>{place.meta_title}</title>
                <meta
                    name="description"
                    content={maxString(place.meta_desc, 154)}
                />
            </Head>
            <PageContextWrapper
                page='landing'
                page_content={data.template_page_content}
            >
                <LandingPageLayout {...data} />
            </PageContextWrapper>
        </>
    );
};

export async function getServerSideProps({ req, res, params }) {
    const { slug } = params;
    const { headers } = getClientIp(req);

    try {
        const apiReq = await fetch(`${process.env.BASE_API_URL}get-area/${slug}`, { headers });

        let data = null;

        try {
            data = await apiReq.json();
        } catch (error) {
            console.error('Invalid API response:', error);
        }

        const rateLimitRedirect = handleRateLimit(res, apiReq, data);
        if (rateLimitRedirect) return rateLimitRedirect;

        if (!data || data?.status == 'failed' || data?.exception) {
            return { notFound: true }
        }

        return {
            props: {
                data
            }
        };

    } catch (error) {
        return { notFound: true }
    }
}

// export async function getStaticProps({params}) {
//     const {slug} = params;

//     try {
//         const req = await fetch(`${process.env.NEXT_PUBLIC_BASE_API_URL}get-area/${slug}`);
//         const request = await fetch(`${process.env.NEXT_PUBLIC_BASE_API_URL}get-home-content`);
//         const new_data = await request.json()
//         const data = await req.json()

//         if(data.exception || new_data.exception) {
//             return {notFound: true}
//         }

//         return {
//             props: {
//                 data, new_data
//              },
//              revalidate: (1000 * 60)
//         };

//     } catch (error) {
//         return {notFound: true} //404
//     }
// }

// export async function getStaticPaths() {
//     return {
//       paths: [],
//       fallback: 'blocking',
//     }
// }


export default area;
